<template>
  <div class="Plan">
    <div class="flex">
      <div class="lt-area flex-auto">
        <el-input
          class="input-with-select"
          size="mini"
          v-model="searchWord"
          :placeholder="placeholder"
          @keydown.enter.native="handleClickFilter"
        >
          <el-button slot="append" icon="el-icon-search" @click="handleClickFilter" />
        </el-input>

        <div class="right-search-head inline" style="margin-left: 10px">
          <div class="inline">
            <APeriodSelector ref="period" @change="handleChangePeriod" />
          </div>
          <div class="inline">
            <el-button
              type="primary"
              size="mini"
              round
              v-shortkey="['f5']"
              @shortkey.native="handleClickSearch"
              @click="handleClickSearch"
            >{{ $t("button.search") }} (F5)</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="row-splitter half-height">
      <ATable
        ref="table"
        class="no-pointer"
        v-loading="loading_contract"
        hide-button-insert
        :data="filterItemsContract"
        :autoHeight="true"
        @selection-change="handleContractSelectionChange"
      >
        <div slot="search">
          <div class="page-subtitle">{{ $t("lang.list_title_plan") }}</div>
        </div>
        <el-table-column type="selection" align="center" :width="$width.selection" />
        <el-table-column
          type="index"
          label="No"
          :width="$width.index"
          :index="handleIndex"
          fixed
        />
        <el-table-column
          prop="contract_date"
          :label="$t('lang.contract_date')"
          :width="$width.date"
          :formatter="util.dateFormat"
        ></el-table-column>
        <el-table-column prop="code" :label="$t('lang.contract_code')" width="90" />
        <el-table-column prop="customer_name" label="거래처" width="100" show-overflow-tooltip />
        <el-table-column prop="product_name" label="품목" width="200" show-overflow-tooltip />
        <el-table-column prop="amount" :label="$t('lang.contract_amount')" width="60" />
        <el-table-column prop="production_amount" :label="$t('lang.production_amount')" width="60" />
        <el-table-column
          prop="delivery_date"
          :label="$t('lang.delivery_date')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column :label="$t('lang.specification')" show-overflow-tooltip>
          <template slot-scope="scope">{{ resolveSpecifications(scope.row) }}</template>
        </el-table-column>
        <el-table-column prop="created_user_name" label="등록인" :width="$width.username" />
        <div slot="buttons">
          <el-button
            type="primary"
            :disabled="contractSelection.length < 1"
            @click="handleClickSaveSale"
          >생산 등록</el-button>
        </div>
      </ATable>
    </div>

    <div class="row-splitter half-height">
      <ATable
        ref="table2"
        v-loading="loading_production"
        hide-button-insert
        buttons-width="240px"
        :data="filterItemsProduction"
        :autoHeight="true"
        @row-click="handleProductionRowClick"
        @selection-change="handleProductionSelectionChange"
      >
        <div slot="search">
          <div class="page-subtitle">{{ $t("lang.list_title_production_plan") }}</div>
        </div>
        <el-table-column type="selection" align="center" :width="$width.selection" />
        <el-table-column type="index" label="No" align="center" :index="handleIndex2" fixed />
        <el-table-column
          prop="delivery_date"
          :label="$t('lang.delivery_date')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column prop="code" label="생산번호" width="90" />
        <el-table-column prop="customer_name" label="거래처" width="100" show-overflow-tooltip />
        <el-table-column prop="product_name" label="품목" width="80" show-overflow-tooltip />
        <el-table-column prop="contract_amount" :label="$t('lang.contract_amount')" width="60" />
        <el-table-column prop="plan_amount" :label="$t('lang.amount')" width="60" />
        <el-table-column
          prop="plan_date"
          :label="$t('lang.production_plan_date')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="specification"
          :label="$t('lang.specification')"
          show-overflow-tooltip
        />
        <!-- <el-table-column :label="$t('lang.project_number')" width="80">
          <template slot-scope="scope">{{ resolveProcess(scope.row.process_id) }}</template>
        </el-table-column> -->
        <el-table-column prop="status_flag" label="상태" :width="80">
          <template slot-scope="scope">{{ resolveProductionStatus(scope.row.status_flag) }}</template>
        </el-table-column>
        <el-table-column prop="created_user_name" label="등록인" :width="$width.username" />
        <div slot="buttons">
          <div class="inline" style="margin-right: 10px">
            <el-button type="primary" @click="handleClickAddProduction">생산 계획 등록</el-button>
          </div>
          <div class="inline">
            <el-button
              type="danger"
              :disabled="productionSelection.length < 1"
              @click="handelClickDelProduction"
            >생산 취소</el-button>
          </div>
        </div>
      </ATable>
    </div>

    <el-dialog
      title="생산 등록"
      top="0"
      custom-class="form-dialog"
      destroyOnClose
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      @opened="handleOpened"
    >
      <PlanForm ref="form" :data="form_data" @completed="handleCompleted"></PlanForm>
    </el-dialog>
  </div>
</template>
<script>
// import { mapGetters } from "vuex";
import { form_container } from "@/common/mixins/form_container";
import { production_process } from "@/common/mixins/production_process";
import PlanForm from "./PlanForm";

export default {
  name: "Sale",
  mixins: [form_container, production_process],
  components: { PlanForm },
  data() {
    return {
      title: this.$t("title.production_plan"),
      dialogVisible: false,
      placeholder: "수주번호, 거래처, 품목",
      search_field: ["code", "customer_name", "product_name"],
      search_fieldSale: ["contract_code", "delivery_date", "product_name"],
      searchWord: null,
      fixedSearchWord: "",

      loading_contract: false,
      items_contract: [],
      contractSelection: [],

      loading_production: false,
      items_production: [],
      productionSelection: [],

      form_data: undefined
    };
  },
  computed: {
    // ...mapGetters(["table_process"]),
    filterItemsContract() {
      return this.util.filterMultiFields(
        this.items_contract,
        this.search_field,
        this.fixedSearchWord
      );
    },
    filterItemsProduction() {
      return this.util.filterMultiFields(
        this.items_production,
        this.search_field,
        this.fixedSearchWord
      );
    },
  },
  mounted() {
    this.$nextTick(() => this.loadData());
  },
  methods: {
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) {
        return;
      }
      this.loadData();
    },
    handleContractSelectionChange(selection) {
      // 수주 선택 처리
      this.contractSelection = selection;
    },
    handleProductionSelectionChange(selection) {
      // 생산 지시 선택 처리
      this.productionSelection = selection;
    },
    handleProductionRowClick(select) {
      this.openDialog(select);
    },
    handleClickFilter() {
      this.fixedSearchWord = this.searchWord;
    },
    loadData() {
      this.loading_contract = true;
      this.api.listProductionContractPeriod(this.period).then(res => {
        this.loading_contract = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items_contract = res.data;
      });
      this.loading_production = true;
      this.api.listProduction(this.period).then(res => {
        this.loading_production = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items_production = res.data;
      });
    },
    /** 다이얼로그 팝업 */
    openDialog(data) {
      let clone = data ? Object.assign({}, data) : undefined;
      this.form_data = clone;
      this.dialogVisible = true;
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleIndex2(index) {
      return this.$refs.table2.indexResolver(index);
    },
    handleClickSaveSale() {
      if (this.contractSelection.length < 1) {
        this.util.notify(
          this,
          "w",
          this.$t("lang.production"),
          this.$t("message.no_selection")
        );
        return;
      }
      let params = [];
      this.contractSelection.forEach(item => {
        params.push({
          id: item.id,
          specification: this.resolveSpecifications(item)
        });
      });
      this.processProduction(
        "생산 등록 중입니다.",
        () => this.api.registerProduction(params),
        // 생산은 건별로 처리되므로 오류가 나도 앞 건은 반영되어 있다.
        { always: () => this.loadData() }
      );
    },
    handleClickAddProduction() {
      this.openDialog();
    },
    handelClickDelProduction() {
      this.util.confirm_delete(this, this.$t("lang.production"), this.doDelete);
    },
    handleCompleted(message) {
      this.dialogVisible = false;
      if (!message) {
        return;
      }
      this.$notify(message);
      this.loadData();
    },
    doDelete() {
      let params = [];
      this.productionSelection.forEach(item => {
        if (item.id !== 0) params.push(item.id);
      });
      this.processProduction(
        "생산 취소 중입니다.",
        () => this.api.deleteProduction(params),
        // 생산은 건별로 처리되므로 오류가 나도 앞 건은 반영되어 있다.
        { always: () => this.loadData() }
      );
    },
    resolveStatus(item) {
      if (item) {
        let fix_amount = item.fix_amount ? item.fix_amount : 0;
        let amount = item.amount;

        if (fix_amount === 0) {
          return "견적";
        } else if (fix_amount < amount) {
          return "진행";
        } else if (fix_amount === amount) {
          return "매출";
        } else {
          return "매출 초과";
        }
      }

      return null;
    },
    resolveStatusSale(item) {
      if (item) {
        let fix_amount = item.fix_amount ? item.fix_amount : 0;
        let amount = item.amount;

        if (fix_amount === 0) {
          return "매출";
        } else if (fix_amount < amount) {
          return "진행";
        } else if (fix_amount === amount) {
          return "견적";
        } else {
          return "매출 초과";
        }
      }
      return null;
    },
    resolveDeliveryWayFlag(val) {
      let flag = this.system.options.delivery_way_flag.find(
        f => f.value === val
      );
      if (!flag) return "";
      return flag.label;
    },
    // resolveProcess(val) {
    //   let process = this.table_process.find(p => p.id === val);
    //   if (!process) return "";
    //   return process.name;
    // },
    resolveProductionStatus(val) {
      let ret = "";
      switch (val) {
        case "1":
          ret = "진행";
          break;
      }
      return ret;
    },
    resolveSpecifications(row) {
      if (row.specifications.length < 1) {
        return "";
      }
      let ret = "";
      row.specifications.forEach(s => {
        if (ret !== "") {
          ret += ", ";
        }
        ret += s.product_name + ": " + s.amount + s.unit_name;
      });
      return ret;
    }
  }
};
</script>
<style lang="scss">
.half-height {
  height: calc(50% - 40px);
}
</style>
